import { render, staticRenderFns } from "./social.vue?vue&type=template&id=5127d31e&scoped=true&"
import script from "./social.vue?vue&type=script&lang=js&"
export * from "./social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127d31e",
  null
  
)

export default component.exports